
import Vue from "vue";
import { ISelectItem } from "../classes/select-item";
import { Validatable } from "../mixins/validatable";

export default Validatable.extend({
	data() {
		return {
			opened: false,
			focused: false,
			keyboardNavigation: false
		};
	},

	props: {
		value: {
			type: Array as () => any[],
			default():any[] {
				return [];
			}
		},
		disabled: {
			type: Boolean,
		},
		items: {
			type: Array as () => ISelectItem<any>[],
			default():ISelectItem<any>[] {
				return [];
			}
		},
		up: {
			type: Boolean
		},
		html: {
			type: Boolean
		},
		label: {
			type: [String, Object],
			default: null
		},
		emptyText: {
			type: [String, Object],
			default: ""
		},
		filter: Boolean,
		closeOnClick: {
			type: Boolean,
		},
		fancy: Boolean,
		light: Boolean,
		disableDeselect: Boolean,
		right: Boolean,
		hasError: Boolean
	},

	watch: {
		async opened(value:boolean) {
			if (!value) return;
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					let items = this.$refs.items as Vue[];
					if (!items) return;
					if (!items[0]) return;
					(items[0] as any).focus();
				});
			});
		}
	},

	computed: {
		text(): string {
			if (this.value.length == 0) return this.emptyText;
			//let replace = this.html ? '/<([^>]+?)([^>]*?)>(.*?)<\\/\\1> /ig' : '';
			return this.items.filter((item) => this.isSelected(item))
				.map((v: any) => v.text.replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1> /ig, "")).join(", ");
		},
		tabindex(): number {
			if (this.disabled) return -1;
			return 0;
		},
		angleDirection(): string {
			if (this.opened)
				return "angle-down";
			return "angle-down";
		},
		selectElement(): HTMLDivElement {
			return this.$refs.select as HTMLDivElement;
		},
		menu(): any {
			return this.$refs.menu;
		},
		hasText():boolean {
			return this.text.trim() != "";
		},
		roundedTop():boolean {
			if (this.light) return true;
			if (this.up) return true;
			return false;
		},
		roundedBottom():boolean {
			if (this.light) return true;
			if (!this.up) return true;
			return false;
		}
	},

	methods: {
		toggle() {
			if (this.disabled) {
				this.close();
				return;
			}
			if (!this.menu) return;
			this.menu.toggle();
		},
		close() {
			if (!this.menu) return;
			this.menu.close();
		},
		open() {
			if (!this.menu) return;
			this.menu.open();
			this.selectElement.focus();
		},
		focus() {
			this.selectElement.focus();
		},
		blur() {
			this.selectElement.blur();
		},
		onEnter(item:any){
			if (this.keyboardNavigation){
				this.itemClicked(item);
			}
		},
		onKeyup(event:KeyboardEvent){
			this.$emit("keyup", event);
		},
		itemClicked(option: any) {
			let i = this.value.indexOf(option.value);
			if (i == -1) {
				this.value.push(option.value);
				this.$emit("input", this.value);
			} else if (!this.disableDeselect) {
				this.value.splice(i, 1);
				this.$emit("input", this.value);
			}
			if (this.closeOnClick) {
				this.close();
				this.selectElement.focus();
			}
		},

		onFocus() {
			if (this.disabled) {
				this.blur();
			} else {
				this.focused = true;
			}
		},
		onBlur() {
			requestAnimationFrame(() => {
				let rootDiv = this.$refs.root as HTMLDivElement;
				if (!this.$refs.itemsDiv) {
					var itemsDiv = undefined as HTMLElement | undefined;
				} else {
					var itemsDiv = (this.$refs.itemsDiv as Vue).$el as HTMLElement | undefined;
				}
				if (rootDiv) {
					if (rootDiv.contains(document.activeElement)) {
						return;
					}
				}
				if (itemsDiv) {
					if (itemsDiv.contains(document.activeElement)) {
						return;
					}
				}
				this.focused = false;
				this.close();
			});
		},

		isSelected(item: ISelectItem<any>):boolean {
			for (let v of this.value) {
				if (v === item.value){
					return true;
				}
			}
			return false;
		},
	}
});
